import { HomeOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Col, Row, Space, Typography } from 'antd';

const { Title, Text } = Typography;

const ErrorPage = () => {
    const lang = {
        title: 'Oops! Something went wrong.',
        description: 'An unexpected error occurred. Try reloading the page or return to the homepage.',
        reload: 'Reload',
        home: 'Go to Home'
    };

    return (
        <Row justify="center" align="middle" style={{ minHeight: '100vh', textAlign: 'center', padding: '2rem' }}>
            <Col>
                <Title level={2}>{lang.title}</Title>
                <Text type="secondary">{lang.description}</Text><br /><br />
                <Space style={{ marginTop: 24 }}>
                    <Button icon={<ReloadOutlined />} onClick={() => window.location.reload()}>
                        {lang.reload}
                    </Button>
                    <Button type="primary" icon={<HomeOutlined />} onClick={() => window.location.href = '/'}>
                        {lang.home}
                    </Button>
                </Space>
            </Col>
        </Row>
    );
};

export default ErrorPage;
